import script from "./TaskCardHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCardHelp.vue?vue&type=script&setup=true&lang=js"

import "./TaskCardHelp.vue?vue&type=style&index=0&id=fe831262&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe831262"]])

export default __exports__